import React, { useEffect, useState } from 'react';

export default function VotesVisualisationPage() {
  return (
    <p>TODO</p>
  )
}